import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Row, Col, Form as BsForm, Button } from 'react-bootstrap';
import Select from 'react-select';
import { customStyles } from '~/Styles/reactSelectStyles';

const OPCOES_DISPARO = [
  { value: 'CPF', label: 'Por CPF' },
  { value: 'CONTRATO', label: 'Por Contrato' },
];

const validacao = Yup.object({
  codigos_cobrador: Yup.array()
    .min(1, 'Selecione ao menos um cobrador')
    .required('Selecione ao menos um cobrador'),
});

const FiltrosJuridico = ({
  cobradores,
  ges,
  clientes,
  onPesquisar,
  onLimpar,
  onConfigurarMensagem,
  onGeChange,
  loading,
}) => {
  const opcoesCobradores = (cobradores || []).map((c) => ({
    value: c.codigo_conta,
    label: c.nome_prestador,
  }));

  const opcoesGes = (ges || []).map((g) => ({
    value: g.codigo_grupo_empresa,
    label: g.sigla,
  }));

  const opcoesClientes = (clientes || []).map((c) => ({
    value: c.codigo_conta,
    label: `${c.nome} (${c.cpf})`,
  }));

  const initialValues = {
    tipo_disparo: 'CPF',
    codigos_cobrador: [],
    codigo_grupo_empresa: null,
    codigo_conta: null,
  };

  const handleSubmit = (values) => {
    onPesquisar({
      modo: 'J',
      tipo: 'J',
      tipo_disparo: values.tipo_disparo,
      codigos_cobrador: values.codigos_cobrador.map((o) => o.value),
      codigo_grupo_empresa: values.codigo_grupo_empresa
        ? values.codigo_grupo_empresa.value
        : null,
      codigo_conta: values.codigo_conta ? values.codigo_conta.value : null,
    });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validacao}
      onSubmit={handleSubmit}
    >
      {({ values, errors, touched, setFieldValue, resetForm }) => (
        <Form>
          <Row className="mb-2">
            <Col md={3}>
              <BsForm.Group>
                <BsForm.Label>GE (opcional)</BsForm.Label>
                <Select
                  styles={customStyles}
                  options={opcoesGes}
                  value={values.codigo_grupo_empresa}
                  onChange={(op) => {
                    setFieldValue('codigo_grupo_empresa', op);
                    setFieldValue('codigo_conta', null);
                    if (onGeChange) onGeChange(op ? op.value : null);
                  }}
                  isClearable
                  placeholder="Selecione a GE..."
                />
              </BsForm.Group>
            </Col>
            <Col md={3}>
              <BsForm.Group>
                <BsForm.Label>Cliente (opcional)</BsForm.Label>
                <Select
                  styles={customStyles}
                  options={opcoesClientes}
                  value={values.codigo_conta}
                  onChange={(op) => setFieldValue('codigo_conta', op)}
                  isClearable
                  isDisabled={!values.codigo_grupo_empresa}
                  placeholder="Selecione o cliente..."
                  noOptionsMessage={() => 'Selecione uma GE primeiro'}
                />
              </BsForm.Group>
            </Col>
            <Col md={3}>
              <BsForm.Group>
                <BsForm.Label>Tipo de Disparo</BsForm.Label>
                <Select
                  styles={customStyles}
                  options={OPCOES_DISPARO}
                  value={OPCOES_DISPARO.find((o) => o.value === values.tipo_disparo)}
                  onChange={(op) => setFieldValue('tipo_disparo', op ? op.value : 'CPF')}
                  placeholder="Selecione..."
                />
              </BsForm.Group>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col md={12}>
              <BsForm.Group>
                <BsForm.Label>Cobradores</BsForm.Label>
                <Select
                  styles={customStyles}
                  isMulti
                  options={opcoesCobradores}
                  value={values.codigos_cobrador}
                  onChange={(selecionados) =>
                    setFieldValue('codigos_cobrador', selecionados || [])
                  }
                  placeholder="Selecione os cobradores..."
                  noOptionsMessage={() => 'Nenhum cobrador encontrado'}
                />
                {touched.codigos_cobrador && errors.codigos_cobrador && (
                  <BsForm.Text className="text-danger">
                    {errors.codigos_cobrador}
                  </BsForm.Text>
                )}
              </BsForm.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button type="submit" variant="primary" disabled={loading} className="mr-2">
                {loading ? 'Pesquisando...' : 'Pesquisar'}
              </Button>
              <Button
                type="button"
                variant="secondary"
                className="mr-2"
                onClick={() => {
                  resetForm();
                  onLimpar();
                }}
              >
                Limpar
              </Button>
              <Button type="button" variant="outline-secondary" onClick={onConfigurarMensagem}>
                Configurar Mensagem
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default FiltrosJuridico;
